const PERMISSIONS_FULFILLMENT_PAGE = {
   VIEW: 'voucher_fulfillment::get'
} as const;

export default PERMISSIONS_FULFILLMENT_PAGE;